import styled from 'styled-components';
import { Colors } from 'basic-ui-lib/constants';
import { Text } from 'basic-ui-lib/components/Text';
import { IcChevronDown } from 'basic-ui-lib/icons';
import { Col } from 'basic-ui-lib';
import { useEffect, useMemo, useState } from 'react';
import useGetListPlaylists from 'modules/playlist/services/hooks/useGetListPlaylists';
import PlaylistPickerModal from './PlaylistPickerModal';

interface PlaylistPickerMobileProps {
  value?: string;
  onChange?: (playlistId: string) => void;
}

const PlaylistPickerMobile = ({ value, onChange }: PlaylistPickerMobileProps) => {
  const [playlistsData, , fetchPlaylists] = useGetListPlaylists(true);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    fetchPlaylists({ page: 1, size: 50 });
  }, []);

  const playlistOptions = useMemo(() => {
    const playlists = playlistsData?.content ?? [];
    return playlists.map((playlist) => ({
      label: playlist.name,
      value: playlist.id,
    }));
  }, [playlistsData]);
  const playlistName = playlistOptions.find((playlist) => playlist.value === value)?.label;
  
  return (
    <>
      <SelectorButton onClick={() => setOpen(true)} type='button'>
        <Col gap={0}>
          <Text caption_4 regular left>
            Playlist
          </Text>
          <TextWrapper>
            <Text caption_3 medium color='neutral.text.5' left ellipsis lineClamp={1}>
              {playlistName || 'Select Playlist'}
            </Text>
          </TextWrapper>
        </Col>
        <IcChevronDown fill={Colors.primary[5]} width={16} height={16} />
      </SelectorButton>

      <PlaylistPickerModal
        value={value}
        onChange={onChange}
        playlistOptions={playlistOptions}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default PlaylistPickerMobile;

const SelectorButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  height: 49px;
  width: 100%;
  background: ${Colors.neutral.bg[1]};
  border: 1px solid ${Colors.neutral.border[1]};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    border-color: ${Colors.primary[5]};
  }

  &:focus {
    border-color: ${Colors.primary[5]};
    outline: none;
  }
`;

const TextWrapper = styled.div`
  flex: 1;
  min-width: 0;
  text-align: left;

  .custom-text {
    max-width: 60px;
  }
`;
